import { ReactElement } from 'react';
import { Pagination as AntPagination } from 'antd';
import { styled } from 'styled-components';

const PaginationBlock = styled.div`
  display: flex;
  justify-content: center;
`;

interface Props {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
}

const Pagination = ({ current, total, pageSize, onChange }: Props): ReactElement => (
  <PaginationBlock>
    <AntPagination current={current} total={total} pageSize={pageSize} onChange={onChange} showSizeChanger={false} />
  </PaginationBlock>
);

export default Pagination;
